import React from 'react';
import MaterialEditor from '../MaterialEditor';

const Step1Material = ({ state, callbacks }) => {
  if (!state.modelUrl && state.objectType === 'model') {
    return (
      <div className="w-full bg-transparent p-0">
        <div className="py-8 px-4 text-center border border-dashed border-dark-border rounded-lg bg-white">
          <p className="text-sm text-dark-text-muted m-0">Bitte laden Sie zuerst ein 3D-Modell hoch.</p>
        </div>
      </div>
    );
  }

  if (state.objectType === 'texture') {
    return (
      <div className="w-full bg-transparent p-0">
        <div className="py-8 px-4 text-center border border-dashed border-dark-border rounded-lg bg-white">
          <p className="text-sm text-dark-text-muted m-0">Material-Editor ist nur für 3D-Modelle verfügbar.</p>
        </div>
      </div>
    );
  }

  return (
    <div className="w-full bg-transparent p-0">
      <MaterialEditor
        material={state.material}
        onMaterialChange={(newMaterial) => {
          callbacks.setMaterial(newMaterial);
        }}
        onTexturesChange={(newTextures) => {
          callbacks.setMaterialTextures(newTextures);
        }}
      />
    </div>
  );
};

export default Step1Material;
